export default {
  usa: {
    site_usa_1: [
      {
        data_captured: 1400,
        data_missing: 401
      }
    ],
    site_usa_2: [
      {
        data_captured: 1304,
        data_missing: 105
      }
    ],
    site_usa_3: [
      {
        data_captured: 2000,
        data_missing: 500
      }
    ]
  },
  france: {
    paris_site: [
      {
        data_captured: 3604,
        data_missing: 602
      }
    ],
    bordeaux_site: [
      {
        data_captured: 2503,
        data_missing: 701
      }
    ],
    nice_site: [
      {
        data_captured: 6700,
        data_missing: 1004
      }
    ]
  },
  sweden: {
    uppsala_site: [
      {
        data_captured: 4100,
        data_missing: 1502
      }
    ],
    stockholm_site: [
      {
        data_captured: 10000,
        data_missing: 2300
      }
    ],
    gothenburg_site: [
      {
        data_captured: 333,
        data_missing: 99
      }
    ]
  },
  german: {
    berlin_site: [
      {
        data_captured: 7100,
        data_missing: 4500
      }
    ],
    leipzig_site: [
      {
        data_captured: 2300,
        data_missing: 1300
      }
    ],
    dresden_site: [
      {
        data_captured: 5600,
        data_missing: 1001
      }
    ]
  },
  netherlands: {
    rotterdam_site: [
      {
        data_captured: 1900,
        data_missing: 200
      }
    ],
    hague_site: [
      {
        data_captured: 4100,
        data_missing: 521
      }
    ],
    utrech_site: [
      {
        data_captured: 1849,
        data_missing: 556
      }
    ],
    leiden_site: [
      {
        data_captured: 3899,
        data_missing: 400
      }
    ],
    groningen_site: [
      {
        data_captured: 4000,
        data_missing: 129
      }
    ],
    breda_site: [
      {
        data_captured: 5000,
        data_missing: 1932
      }
    ]
  }
};
